import clsx from "clsx";
import type { ReactNode } from "react";
import { useNavigation } from "react-router";

export const AppFrame = ({
	children,
}: {
	children?: ReactNode | undefined;
}) => {
	return (
		<div className="h-screen w-full flex-col overflow-auto sm:flex sm:flex-row">
			{children}
		</div>
	);
};

export const MainFrame = ({
	children,
}: {
	children?: ReactNode | undefined;
}) => {
	const navigation = useNavigation();

	return (
		// WHY scrollbar-gutter here: <main> is stretched to the viewport and is the element that scrolls; pages that scroll lost ~15px to the scrollbar, nudging the header search sideways between pages.
		<main
			className={clsx(
				"min-h-screen grow overflow-x-hidden [scrollbar-gutter:stable] transition-opacity",
				navigation.state === "loading"
					? "opacity-40 pointer-events-none"
					: null,
			)}
		>
			{children}
		</main>
	);
};
